import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ClipboardList } from 'lucide-react';
import { inputStyle, labelStyle, helpStyle } from './quote/quoteStyles';

const SERVICES = [
  { value: 'process-serving', label: 'Process Serving' },
  { value: 'court-filing', label: 'Court Filing (in person)' },
  { value: 'e-filing', label: 'E-Filing' },
  { value: 'document-retrieval', label: 'Document Retrieval' },
  { value: 'skip-tracing', label: 'Skip Tracing' },
  { value: 'county-recording', label: 'County Recording' }
];

export const QuickQuoteStart = () => {
  const navigate = useNavigate();
  const [service, setService] = useState('');
  const [email, setEmail] = useState('');

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams({ service });
    if (email) params.set('email', email);
    navigate(`/quote?${params.toString()}`);
  };

  return (
    <form onSubmit={submit} data-testid="quick-quote-form" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div>
        <label htmlFor="quick-quote-service" style={labelStyle}>What do you need? <span style={{ color: '#c53030' }}>*</span></label>
        <select id="quick-quote-service" data-testid="quick-quote-service" required value={service} onChange={(e) => setService(e.target.value)} style={inputStyle}>
          <option value="">Select a service...</option>
          {SERVICES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>
      <div>
        <label htmlFor="quick-quote-email" style={labelStyle}>Your email</label>
        <input id="quick-quote-email" data-testid="quick-quote-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" style={inputStyle} />
        <p style={helpStyle}>We'll pre-fill it on the next step. Your quote is emailed - no phone call needed.</p>
      </div>
      <button type="submit" className="btn-primary" data-testid="quick-quote-continue" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', fontSize: '1.05rem' }}>
        Continue to the Questionnaire <ArrowRight size={18} />
      </button>
      <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', padding: '1rem', borderRadius: '8px', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-medium)' }}>
        <ClipboardList size={20} color="var(--brand-primary)" style={{ flexShrink: 0, marginTop: '2px' }} />
        <p className="body-small" style={{ margin: 0, color: 'var(--text-secondary)' }}>
          The questionnaire takes about 3 minutes and asks only what we need for an accurate quote - document type, deadline, addresses, and whether sub-service is allowed.
        </p>
      </div>
    </form>
  );
};
